import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frame"]
  static values = { tariffId: String, url: String }

  declare frameTarget: HTMLElement
  declare tariffIdValue: string
  declare urlValue: string

  typeChanged(event: Event) {
    const select = event.target as HTMLSelectElement
    const params = new URLSearchParams({ type: select.value })

    if (this.tariffIdValue) params.set("tariff_id", this.tariffIdValue)
    this.frameTarget.setAttribute("src", `${this.urlValue}?${params}`)
  }
}
